"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
require("../spinner.types");
const spinner_icon_styles_1 = require("./spinner-icon.styles");
const SpinnerIcon = ({ inverse, color, size }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(spinner_icon_styles_1.SvgWrapper, { size: size },
        react_1.default.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M18 9.5C18 14.1944 14.1944 18 9.5 18C4.80558 18 1 14.1944 1 9.5C1 4.80558 4.80558 1 9.5 1", stroke: color
                    ? color
                    : inverse
                        ? theme.colors.icon.inverse
                        : theme.colors.icon.secondary, strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }))));
};
exports.SpinnerIcon = SpinnerIcon;
